<template>
<nav :class="['sidebar overflow-hidden', open ? 'sidebar_open' : '!w-[80px] sidebar_close']"> 
    <div class="sidebar-top">
        <div>&nbsp</div>
        <div class="menu-switch" >            
            <div class="menu-switch-icon" @click="clickLeftSwitch">
                <svg v-if="open" fill="currentColor" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.82 10.5h3.68a.5.5 0 0 0 0-1h-3.68l1-.87a.5.5 0 1 0-.66-.76l-2 1.75a.5.5 0 0 0 0 .76l2 1.75a.5.5 0 1 0 .66-.76l-1-.87ZM4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4ZM3 6a1 1 0 0 1 1-1h3v10H4a1 1 0 0 1-1-1V6Zm5 9V5h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8Z" fill="currentColor"></path></svg>
                <svg v-else fill="currentColor" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m13.18 10.5-1 .87a.5.5 0 0 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.66.76l1 .87H9.5a.5.5 0 0 0 0 1h3.68ZM2 14c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8Zm2 1a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h3v10H4Zm4 0V5h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8Z" fill="currentColor"></path></svg>
            </div>
        </div>        
    </div>
    <div class="sidebar-center">
        <div class="sidebar-content">
            <UserCenterSideMenuGroup v-for="(item, index) in menuList" :info="item.info" :key="index" :subMenus="item.subMenus" :currentMenuUrl="currentMenuUrl" :open="open">
            </UserCenterSideMenuGroup>            
        </div>
    </div>
</nav>
</template>

<script>
import UserCenterSideMenuGroup from './UserCenterSideMenuGroup.vue';

export default {
  components: {
    UserCenterSideMenuGroup
  },
  data() {
    return {
      open: true,      
    }
  },
  props: {
    currentMenuUrl: {
        type: String,
        default: ''
    }
  },
  computed: {
    menuList() {
        return this.$t("cpts.ucenter_sidebar.menu");
    },
  },
  created() {
    this.open = localStorage.getItem('sidebar_open') === 'false' ? false : true;
  },
  
  methods: {
    getImg(area) {
      return require(`@/assets/index/img/${area}`);
    },

    clickLeftSwitch() {
        this.open = !this.open
        localStorage.setItem('sidebar_open', this.open);
    },
  }
}
</script>

<style lang="scss" scoped>

 .sidebar {    
    display: flex;
    flex-direction: column;
    flex-shrink: 0;    
    width: 216px;
    max-width: 216px;      
    box-sizing: border-box;    
    // box-shadow: 1px 0px 10px 0px rgba(0,0,0,0.1);
    background-color: inherit;
    transition: all 0.5s;
}

 .sidebar .sidebar-top {    
    position: relative;
    width: 100%;
    height: 36px;
    box-sizing: border-box;
    display: block;
    justify-content: center;
    align-items: center
}

 .sidebar .sidebar-top .menu-switch {    
    position: absolute;
    left: 28px;
    top: calc(10px + 50%);
    transform: translate(0%, -50%);
    z-index: 10;
    height: 100%;
    background: linear-gradient(to right, #fff, transparent)
}

 .sidebar .sidebar-top .menu-switch .menu-switch-icon {
    position: relative;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer
}

 .sidebar .sidebar-top .menu-switch .menu-switch-icon .check-menu-open {
    display: none
}

.sidebar .sidebar-top .menu-top-icon {
    width: 100%;
    height: 100%
}

.sidebar .sidebar-center {
    padding: 22px 20px;
    width: 100%;
    border-radius: 0;
    box-sizing: border-box
}

.sidebar .sidebar-center .sidebar-content {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;    
    width: 100%;    
    height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none
}

.sidebar .sidebar-center .sidebar-content::-webkit-scrollbar {
    display: none;
    width: 0 !important
}

.sidebar.sidebar_open {
    width: 296px
}

 .sidebar.sidebar_close {
    width: 296px
}

// @media screen and (max-width: 1200px) {
//      .sidebar {
//         width:0
//     }

//      .sidebar .sidebar-top .menu-switch {
//         display: block
//     }

//      .sidebar .sidebar-top .menu-top-icon {
//         display: none
//     }

//      .sidebar .sidebar-center {
//         display: none
//     }

//      .sidebar.sidebar_open {
//         width: 296px
//     }

//      .sidebar.sidebar_open .sidebar-top .menu-switch {
//         display: block
//     }

//      .sidebar.sidebar_open .sidebar-top .menu-switch .check-button-label .anima-line.anima-line-1 {
//         transform: translate3d(-50%, 0, 0) rotate(63deg);
//         -ms-transform: translate3d(-50%, 0, 0) rotate(45deg);
//         -moz-transform: translate3d(-50%, 0, 0) rotate(45deg);
//         -o-transform: translate3d(-50%, 0, 0) rotate(45deg);
//         -webkit-transform: translate3d(-50%, 0, 0) rotate(45deg)
//     }

//      .sidebar.sidebar_open .sidebar-top .menu-switch .check-button-label .anima-line.anima-line-2 {
//         transform: translate3d(-50%, 0, 0) scale(0.1, 1);
//         -ms-transform: translate3d(-50%, 0, 0) scale(0.1, 1);
//         -moz-transform: translate3d(-50%, 0, 0) scale(0.1, 1);
//         -o-transform: translate3d(-50%, 0, 0) scale(0.1, 1);
//         -webkit-transform: translate3d(-50%, 0, 0) scale(0.1, 1)
//     }

//      .sidebar.sidebar_open .sidebar-top .menu-switch .check-button-label .anima-line.anima-line-3 {
//         transform: translate3d(-50%, 0, 0) rotate(-45deg);
//         -ms-transform: translate3d(-50%, 0, 0) rotate(-45deg);
//         -moz-transform: translate3d(-50%, 0, 0) rotate(-45deg);
//         -o-transform: translate3d(-50%, 0, 0) rotate(-45deg);
//         -webkit-transform: translate3d(-50%, 0, 0) rotate(-45deg)
//     }

//      .sidebar.sidebar_open .sidebar-top .menu-top-icon {
//         display: block
//     }

//      .sidebar.sidebar_open .sidebar-center {
//         display: block
//     }

//      .sidebar.sidebar_close {
//         width: 0
//     }

//      .sidebar.sidebar_close .sidebar-center {
//         display: none
//     }
// }

</style>